import { NgClass, NgTemplateOutlet } from '@angular/common';
import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatOptionModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslatePipe } from '@ngx-translate/core';
import { AbstractFormFieldComponent } from '../../abstract-form-field.component';
import { SelectFormField } from '../../form-field.model';

@Component({
  selector: 'iot-platform-ui-form-dropdown-field',
  imports: [
    FlexLayoutModule,
    TranslatePipe,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatOptionModule,
    MatSelectModule,
    ReactiveFormsModule,
    MatTooltipModule,
    MatProgressSpinnerModule,
    FormsModule,
    NgClass,
    NgTemplateOutlet
  ],
  templateUrl: './form-dropdown-field.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: '../../form-field/form-field.component.scss'
})
export class FormDropdownFieldComponent extends AbstractFormFieldComponent<SelectFormField> implements OnInit {
  trackByFn!: (item: unknown, index?: number) => unknown;

  trackBy = (item: unknown, index?: number) => (this.field()?.trackBy ? this.field()?.trackBy?.(item, index) : index);

  defaultCompareFn(a: unknown, b: unknown): boolean {
    return a === b;
  }

  ngOnInit() {
    super.ngOnInit();
    const control = this.control();
    const field = this.field();
    if (control && field) {
      this.trackByFn = this.trackBy.bind(this);
    }
  }
}
